import { Component, computed, inject, input, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogRef } from '@angular/cdk/dialog';
import { Shared } from '@shared/exports';
import { Alerts } from '@services/alerts/alerts';
import { MultiagendaService, DesbloquearProspectoResponse } from 'src/app/modules/multiagenda/multiagenda.service';

@Component({
  selector: 'app-home-desbloqueo-prospecto',
  standalone: true,
  imports: [FormsModule, Shared],
  templateUrl: './home-desbloqueo-prospecto.html',
  styleUrl: './home-desbloqueo-prospecto.scss',
})
export class HomeDesbloqueoProspecto {
  private readonly dialogRef = inject(DialogRef);
  private readonly multiagendaService = inject(MultiagendaService);
  private readonly alerts = inject(Alerts);

  // Inputs
  $idDistribuidor = input.required<string>({ alias: 'idDistribuidor' });
  $idEjecutivo = input.required<string>({ alias: 'idEjecutivo' });
  $idProspecto = input.required<string>({ alias: 'idProspecto' });

  // Signals
  $observaciones = signal<string>('');
  $loading = signal<boolean>(false);

  // Computed
  $puedeDesbloquear = computed(() => this.$observaciones().trim().length > 0 && !this.$loading());

  onObservacionesChange(event: Event): void {
    const target = event.target as HTMLTextAreaElement;
    this.$observaciones.set(target.value);
  }

  onDesbloquear(): void {
    if (!this.$puedeDesbloquear()) return;

    this.$loading.set(true);

    console.log('PARAMETROS DESBLOQUEO');
    console.log('idDistribuidor', this.$idDistribuidor());
    console.log('idProspecto', this.$idProspecto());
    console.log('observaciones', this.$observaciones());
    console.log('idEjecutivo', this.$idEjecutivo());

    this.multiagendaService.desbloquearProspecto({
      idDistribuidor: this.$idDistribuidor(),
      idProspecto: this.$idProspecto(),
      observacion: this.$observaciones(),
      idUsuario: this.$idEjecutivo(),
    }).subscribe({
      next: (response: DesbloquearProspectoResponse) => {
        this.$loading.set(false);
        if (response.success) {
          this.alerts.show('success', { title: 'Desbloqueado Correctamente', msg: 'El prospecto ha sido desbloqueado' });
          this.dialogRef.close(true);
        } else {
          this.alerts.show('error', { title: 'Error', msg: 'Error al desbloquear el prospecto' });
        }
      },
      error: () => {
        this.$loading.set(false);
        this.alerts.show('error', { title: 'Error', msg: 'Error al desbloquear el prospecto' });
      },
    });
  }
}
